import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("lp_token");
      localStorage.removeItem("lp_user");
      const p = window.location.pathname;
      // Do not redirect if we're already on /login or handling OAuth callback
      if (!p.startsWith("/login") && !window.location.hash?.includes("session_id=")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
